import { SkeletonLoader, TextInputCard } from '@equip.health/ui';

import { GlobalErrorCode } from '~/lib/constants/global.constants';
import useErrorToast from '~/lib/hooks/useErrorToast';
import { useUpdateNextStepsMutation } from '~/store/services/inquiry';

export interface NextStepsProps {
  id: string;
  inquiryId: string;
  version: string;
  isLoading: boolean;
  shouldInvalidate?: boolean;
  value?: string;
}

export const NextSteps = ({
  id,
  isLoading,
  inquiryId,
  version,
  shouldInvalidate,
  value,
}: NextStepsProps) => {
  const { showErrorToast } = useErrorToast();
  const [updateInquiryNextSteps] = useUpdateNextStepsMutation();
  const internalOnChange = (nextSteps: string) => {
    updateInquiryNextSteps({
      inquiryId,
      nextSteps,
      shouldInvalidate: shouldInvalidate ?? true,
      showConflictErrorModal: false,
      version,
    })
      .unwrap()
      .catch((error) => {
        // Lose this when we get inquiry via RTK
        showErrorToast(
          GlobalErrorCode.EDIT_INQUIRY_V2,
          error?.status,
          error?.data?.message,
        );
      });
  };

  return (
    <SkeletonLoader id={id} isLoaded={!isLoading}>
      <TextInputCard
        id={id}
        onChange={internalOnChange}
        title="Next steps"
        value={value}
      />
    </SkeletonLoader>
  );
};
